export enum ChargeOption {
  SUM_TOTAL = { code: 1, description: 'PRODUCT.SUM_TOTAL' } as any,
  HIGHEST_VALUE = { code: 2, description: 'PRODUCT.HIGHEST_VALUE' } as any,
  LOWER_VALUE = { code: 3, description: 'PRODUCT.LOWER_VALUE' } as any,
  AVERAGE = { code: 4, description: 'PRODUCT.AVERAGE' } as any,
}



// WEBPACK FOOTER //
// ./src/app/pages/category/products/enum/charge-option.enum.ts